// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__caNeL","rootSuccess":"CompleteLink_rootSuccess__3xVZ-","rootFailure":"CompleteLink_rootFailure__BaiRr","isDisabled":"CompleteLink_isDisabled__30OK-"};